import { DataSource, HorizontalSpacer, Label, Layout, LayoutHeader, Panel, SaveButton, Tab, Table, Tabset, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutInstanceSettings extends Layout {
    buttonSave: SaveButton;
    horizontalspacer1: HorizontalSpacer;
    labelSecurityBreachNotifications: Label;
    layoutheaderInstanceSettings: LayoutHeader;
    panelDataHeaderAddlRight: Panel;
    sourceInstanceSettings: DataSource;
    sourceNotificationSettings: DataSource;
    tabGeneralSettings: Tab;
    tabSecurityNotifications: Tab;
    tableNotificationSettings: Table;
    tabsetMain: Tabset;
    textboxDevSystemMessage: Textbox;
}
